/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import http from '@/common/http'

export function listEvse(params = {}) {
  return http.post('/cms/evse/list', params)
}
export function listEvseModelBrief(params = {}) {
  return http.post('/cms/evse/model/brief/list', params)
}

export function getEvseModelInfo(params = {}) {
  return http.post('/cms/evse/mode/info', params)
}
export function upsertFirmware(params = {}) {
  return http.post('/cms/evse/firmware/upsert', params)
}
export function getFirmwareList(params = {}) {
  return http.post('/cms/evse/firmware/list', params)
}

export function tracelessEvseOtas(params = {}) {
  return http.post('/cms/evse/ota/traceless', params)
}

export function getEvseOtas(params = {}) {
  return http.post('/cms/evse/ota/list', params)
}
export function addEvseOta(params = {}) {
  return http.post('/cms/evse/ota/upsert', params)
}
export function retryOta(params = {}) {
  return http.post('/cms/evse/ota/retry', params)
}

export function getEvseRunlogList(params = {}) {
  return http.post('/cms/evse/runlog/list', params)
}
export function uploadRunlog(params = {}) {
  return http.post('/cms/evse/runlog/upload', params)
}

export function getEvseProfileList(params = {}) {
  return http.post('/cms/evse/profile/list', params)
}
export function getEvseProfileLately(params = {}) {
  return http.post('/cms/evse/profile/lately', params)
}
export function upsertEvseProfile(params = {}) {
  return http.post('/cms/evse/profile/upsert', params)
}

export function upsertEvse(params = {}) {
  return http.post('/cms/evse/upsert', params)
}
export function delEvse(id: string) {
  return http.post('/cms/evse/delete', {
    evseID: id,
  })
}

export function getEvseInfo(params = {}) {
  return http.post('/cms/evse/info', params)
}
export function getEvseConnector(params = {}) {
  return http.post('/cms/evse/connector/list', params)
}

export function getEvseStat(params = {}) {
  return http.post('/cms/evse/stat', params)
}
export function getEvseStatByType(params = {}) {
  return http.post('/cms/evse/type/stat', params)
}
export function upsertEvseModel(params = {}) {
  return http.post('/cms/evse/mode/upsert', params)
}
export function getEvseModelList(params = {}) {
  return http.post('/cms/evse/mode/list', params)
}

export function evseOperationCtrl(params = {}) {
  return http.post('/cms/evse/operation/ctrl', params)
}

export function getEvseList(params = {}) {
  return http.post('/cms/evse/list', params)
}

export function getEvseOverview(params = {}) {
  return http.post('/cms/evse/overview', params)
}

export function banEvse(id: string, banned: boolean) {
  return http.post('/cms/evse/ban', {
    evseID: id,
    ban: banned,
  })
}

export function sendQrcode(params = {}) {
  return http.post('/cms/evse/send_qrcode', params)
}

export function sendPriceingByEvse(id: string) {
  return http.post('/cms/priceing/send_by_evse', { evseId: id })
}

export function setEvseMode(params = {}) {
  return http.post('/cms/evse/mode/set', params)
}

export function rebootEvse(params = {}) {
  return http.post('/cms/evse/reboot', params)
}
export function resetEvse(params = {}) {
  return http.post('/cms/evse/reset', params)
}

export function evseReboot(params = {}) {
  return http.post('/cms/evse/reboot', params)
}
export function evseReset(params = {}) {
  return http.post('/cms/evse/reset', params)
}
export function evseClearCache(params = {}) {
  return http.post('/cms/evse/clear/cache', params)
}
export function evseClearProfile(params = {}) {
  return http.post('/cms/evse/clear/profile', params)
}
export function evseTriggerConnector(params = {}) {
  return http.post('/cms/evse/trigger/connector', params)
}
export function evseTriggerOrder(params = {}) {
  return http.post('/cms/evse/trigger/order', params)
}
export function evseUnlockConnector(params = {}) {
  return http.post('/cms/evse/unlock/connector', params)
}

export function setConfig(params = {}) {
  return http.post('/cms/evse/config/set', params)
}
export function getConfig(params = {}) {
  return http.post('/cms/evse/config/get', params)
}

export function upgradeEvse(params = {}) {
  return http.post('/cms/evse/upgrade', params)
}
export function evseStopCharging(params = {}) {
  return http.post('/cms/evse/charging/stop', params)
}
export function orderStopCharging(params = {}) {
  return http.post('/cms/order/stop', params)
}

export function getEvseModelBriefList(params = {}) {
  return http.post('/cms/evse/model/brief/list', params)
}

// 储能系统-设备管理：获取储能设备列表
//  rpc GetEssDeviceList(GetEssDeviceListReq) returns (GetEssDeviceListReply)
export function GetEssDeviceList(params = {}) {
  return http.post('/cms/ess/device/list', params)
}

// 储能系统-设备管理：获取指定设备详情
// rpc GetEssDeviceInfo(GetEssDeviceInfoReq) returns (GetEssDeviceInfoReply)
export function GetEssDeviceInfo(params = {}) {
  return http.post('/cms/ess/device/info', params)
}

// 储能系统-设备管理：添加储能设备
// rpc AddEssDevice(AddEssDeviceReq) returns (AddEssDeviceReply)
export function AddEssDevice(params = {}) {
  return http.post('/cms/ess/device/add', params)
}

// 储能系统-设备管理：更新储能设备信息
// rpc UpdateEssDevice(UpdateEssDeviceReq) returns (UpdateEssDeviceReply)
export function UpdateEssDevice(params = {}) {
  return http.post('/cms/ess/device/update', params)
}

// 储能系统-设备管理：删除储能设备
// rpc DeleteEssDevice(DeleteEssDeviceReq) returns (DeleteEssDeviceReply)
export function DeleteEssDevice(params = {}) {
  return http.post('/cms/ess/device/delete', params)
}

// 储能系统-大屏展示：设备监控数据（环形图）
// rpc GetEssDeviceMonitorStats(GetEssDeviceMonitorStatsReq) returns (GetEssDeviceMonitorStatsReply)
export function GetEssDeviceMonitorStats(params = {}) {
  return http.post('/cms/ess/device/monitor/stats', params)
}

// 储能系统-大屏展示：能量增长趋势（曲线图）
// rpc GetEssEnergyGrowthTrend(GetEssEnergyGrowthTrendReq) returns (GetEssEnergyGrowthTrendReply)
export function GetEssEnergyGrowthTrend(params = {}) {
  return http.post('/cms/ess/energy/growth/trend', params)
}

// 储能系统-大屏展示：站点发电排行榜
// rpc GetEssStationRank(GetEssStationRankReq) returns (GetEssStationRankReply)
export function GetEssStationRank(params = {}) {
  return http.post('/cms/ess/station/rank', params)
}

// 储能系统-大屏展示：地理分布 + 汇总统计数据（总储能能量数kWh、年度环比增长率、总设备数、总站点数）
// rpc GetEssStationGeoStats(GetEssStationGeoStatsReq) returns (GetEssStationGeoStatsReply)
export function GetEssStationGeoStats(params = {}) {
  return http.post('/cms/ess/station/geo/stats', params)
}

// 储能系统-大屏展示：能量转换统计数据
// rpc GetEssEnergyConversionStats(GetEssEnergyConversionStatsReq) returns (GetEssEnergyConversionStatsReply)
export function GetEssEnergyConversionStats(params = {}) {
  return http.post('/cms/ess/energy/conversion/stats', params)
}

// 储能系统-大屏展示：能量分析曲线图和柱状图（日/月/季/年）
// rpc GetEssEnergyAnalysisStats(GetEssEnergyAnalysisStatsReq) returns (GetEssEnergyAnalysisStatsReply)
export function GetEssEnergyAnalysisStats(params = {}) {
  return http.post('/cms/ess/energy/analysis/stats', params)
}

// 储能系统-站点总览：发电/放电年度增长率
// rpc GetEssStationYearlyGrowthRate(GetEssStationYearlyGrowthRateReq) returns (GetEssStationYearlyGrowthRateReply)
export function GetEssStationYearlyGrowthRate(params = {}) {
  return http.post('/cms/ess/station/yearly/growth/rate', params)
}

// 储能系统-站点总览：发电/放电当日数据
// rpc GetEssStationDailyData(GetEssStationDailyDataReq) returns (GetEssStationDailyDataReply)
export function GetEssStationDailyData(params = {}) {
  return http.post('/cms/ess/station/daily/data', params)
}

// 储能系统-站点总览：发电/放电日/周堆积图
// rpc GetEssStationStackedChart(GetEssStationStackedChartReq) returns (GetEssStationStackedChartReply)
export function GetEssStationStackedChart(params = {}) {
  return http.post('/cms/ess/station/stacked/chart', params)
}

// 储能系统-站点总览：设备状态数据统计(1、设备在线率 2、设备总告警次数)
// rpc GetEssStationDeviceStatusStats(GetEssStationDeviceStatusStatsReq) returns (GetEssStationDeviceStatusStatsReply)
export function GetEssStationDeviceStatusStats(params = {}) {
  return http.post('/cms/ess/station/device/status/stats', params)
}

// 储能系统-站点总览：年度/月度统计(1、支持年+月下拉选择时间 2、年度和月度tab页 3、显示发电量、放电量、负载功率、自满自足率 [没有的字段先预留接口字段])
// rpc GetEssStationEnergyStats(GetEssStationEnergyStatsReq) returns (GetEssStationEnergyStatsReply)
export function GetEssStationEnergyStats(params = {}) {
  return http.post('/cms/ess/station/energy/stats', params)
}

// 储能系统-站点总览：月度电量站点排行
// rpc GetEssStationMonthlyRank(GetEssStationMonthlyRankReq) returns (GetEssStationMonthlyRankReply)
export function GetEssStationMonthlyRank(params = {}) {
  return http.post('/cms/ess/station/monthly/rank', params)
}

// 储能系统-站点总览：站点综合统计数据(1、站点总数 2、设备总数 3、总发电量 4、总放电量 5、总功率 以上指标均包含月增长率)
// rpc GetEssStationOverview(GetEssStationOverviewReq) returns (GetEssStationOverviewReply)
export function GetEssStationOverview(params = {}) {
  return http.post('/cms/ess/station/overview', params)
}

// 储能系统-站点总览：设备综合统计数据(1、在线比例 2、就绪比例 3、故障比例 4、运营比例)
// rpc GetEssDeviceOverview(GetEssDeviceOverviewReq) returns (GetEssDeviceOverviewReply) {
export function GetEssDeviceOverview(params = {}) {
  return http.post('/cms/ess/device/overview', params)
}

// 储能系统-站点数据总览: 电站状态
export function GetEssStationStatus(params = {}) {
  return http.post('/cms/ess/station/status', params)
}

// 储能系统-站点数据总览: 当前告警状态
export function GetEssAlarmStatus(params = {}) {
  return http.post('/cms/ess/alarm/status', params)
}

// 储能系统-站点数据总览: 电池状态
export function GetEssBatteryStatus(params = {}) {
  return http.post('/cms/ess/battery/status', params)
}

// 储能系统-站点总览：站点能量流转数据
export function GetEssStationFlowData(params = {}) {
  return http.post('/cms/ess/station/flow/data', params)
}

// 储能系统-站点总览：光伏监控数据
export function GetEssStationPvMonitor(params = {}) {
  return http.post('/cms/ess/station/pv/monitor', params)
}

// 储能系统-站点总览：储能监控数据
export function GetEssStationEnergyMonitor(params = {}) {
  return http.post('/cms/ess/station/energy/monitor', params)
}





export function GetPlockList(params = {}) {
  return http.post('/cms/plock/list', params)
}
export function GetPlockInfo(params = {}) {
  return http.post('/cms/plock/info', params)
}
export function UpsertPlock(params = {}) {
  return http.post('/cms/plock/upsert', params)
}
export function DelPlock(params = {}) {
  return http.post('/cms/plock/del', params)
}
export function BindPlock(params = {}) {
  return http.post('/cms/plock/bind', params)
}
export function UnbindPlock(params = {}) {
  return http.post('/cms/plock/unbind', params)
}
export function RefreshPlock(params = {}) {
  return http.post('/cms/plock/refresh', params)
}
export function RebootPlock(params = {}) {
  return http.post('/cms/plock/reboot', params)
}
export function ResetPlock(params = {}) {
  return http.post('/cms/plock/reset', params)
}
export function OpenPlock(params = {}) {
  return http.post('/cms/plock/open', params)
}
export function ClosePlock(params = {}) {
  return http.post('/cms/plock/close', params)
}
export function ClearPLockAlarm(params = {}) {
  return http.post('/cms/plock/clear_alarm', params)
}
export function SetPlockConfig(params = {}) {
  return http.post('/cms/plock/config/set', params)
}
export function GetPlockConfig(params = {}) {
  return http.post('/cms/plock/config/get', params)
}